import { useState } from "react"
import "../Page3/Page3.css"
import text from "../Page3/Images/TextUtils.jpeg"
import wallpaper from "../Page3/Images/WallpaperApp.jpeg"
import weather from "../Page3/Images/WeatherApp.jpeg"
import news from "../Page3/Images/News app.jpeg"
import guess from "../Page3/Images/guess.jpeg"
import pig from "../Page3/Images/Piggame.jpeg"
import blog from "../Page3/Images/blog.jpg"
import outofkind from "../Page3/Images/outofkind.jpg"
import { motion } from 'framer-motion';
export default function Page3(){
    const Projects=[
        {
            name:"Out Of Kind",
            discription:"In this platform user can donate, create and share stories and can search for detailed information of NGO's",
            catogary:"WebSite",
            github:"https://github.com/Infinite-Null/OutOfKind",
            online:"https://out-of-kind.vercel.app/",
            download:"",
            image:outofkind,
        },
        {
            name:"Full Stack Blog Website",
            discription:"Developed a full stack blog website with user auth using next-auth where user can create blogs, view the blogs created by other user, comment on the blogs and even like a blog posted by other users",
            catogary:"WebSite",
            github:"https://github.com/Infinite-Null/Blog",
            online:"https://blog-beta-nine-87.vercel.app/",
            download:"",
            image:blog,
        },
        {
            name:"Full Stack Todo App",
            discription:"Developed a Full Stack Todo App with user authentication where user can create account and login to there respective account and keep track of what to do.",
            catogary:"WebSite",
            github:"https://github.com/Infinite-Null/Full-Stack-Todo-With-Authentication",
            online:"",
            download:"",
            image:"https://play-lh.googleusercontent.com/HUuQc4Zpl6x7fUyX-jFMmcuUbW77REw4UKl5rfhHfP4VY6ctBU1w1I_RZWsXaojFgIo",
        },
        {
            name:"Newsify",
            discription:"Newsify is a news website which helps you to be updated with current happening around the world. It is developed using api provided by \"newsapi.org\"",
            catogary:"WebSite",
            github:"https://github.com/Infinite-Null/W-eather",
            online:"",
            download:"",
            image:"https://cdn.pixabay.com/photo/2017/06/26/19/03/news-2444778_640.jpg",
        },
        {
            name:"Weather Checker Website",
            discription:"Developed a weather checker website using api provided by \"weatherapi.com\" where user can check weather of there respective location.",
            catogary:"WebSite",
            github:"https://github.com/Infinite-Null/W-eather",
            online:"",
            download:"",
            image:"https://store-images.s-microsoft.com/image/apps.16894.c02476d2-2378-4f60-8290-b6d4b3842643.79a2ef6a-4775-4c79-8d93-9caf077660eb.1bbd88a4-0a17-4750-91a0-cd7d98f58e9d",
        },
        {
            name:"Text Utils",
            discription:"Text Utils is website created by using react. Text Utils helps you to count words and letters of your paragraph and perform different operation on that paragraph.",
            catogary:"WebSite",
            github:"https://github.com/Infinite-Null/TextUtils",
            online:"",
            download:"",
            image:text,
        },
        {
            name:"Wallpaper App",
            discription:"A wallpaper app developed using flutter and pixels api where you can look for wallpapers and set it as home screen, lock screen or both's wallpaper",
            catogary:"Applications",
            github:"https://github.com/Infinite-Null/Wall-Paper-app",
            online:"",
            download:"https://github.com/Infinite-Null/Wall-Paper-app/releases/download/v1.0/app-release.apk",
            image:wallpaper,
        },
        {
            name:"Weather App",
            discription:"Developed a Weather app with glassmorphism design using flutter in which you give your city name and it returns you with weather condition of your place.",
            catogary:"Applications",
            github:"https://github.com/Infinite-Null/Wea-ther-App",
            online:"",
            download:"https://github.com/Infinite-Null/Wea-ther-App/releases/download/v1/Wea-ther.apk",
            image:weather,
        },
        {
            name:"News App",
            discription:"News App is an moblie application which shows you latest news in many category which is developed using flutter and inshort api.",
            catogary:"Applications",
            github:"https://github.com/Infinite-Null/Ne-ws-App",
            online:"",
            download:"https://github.com/Infinite-Null/Ne-ws-App/releases/download/v1/Ne-ws.apk",
            image:news,
        }, 
        {
            name:"Guess The Number",
            discription:"A 1 player game developed using html,css and javascript in which a random number is generated and player have to guess the number in as less move as possible.",
            catogary:"Web Games",
            github:"https://github.com/Infinite-Null/GUESS-NUMBER/",
            online:"https://infinite-null.github.io/GUESS-NUMBER/k.html",
            download:"",
            image:guess,
        },
        {
            name:"Pig Game",
            discription:"A 2 player game developed using html,css and javascript in which two people compeat with each other to reach to 100 as soon as possible by rolling a dice.",
            catogary:"Web Games",
            github:"https://github.com/Infinite-Null/Pig-GAme",
            online:"https://infinite-null.github.io/Pig-GAme/",
            download:"",
            image:pig,
        },
    ]
    const [Tab,setTab]=useState(0)
    const changeTab=(i)=>{
        setTab(i);
    }
    const catogary=["Website","Applications","Web Games"]
    return <div>
        <motion.h1 
        id="projectSection"
        initial={{opacity:0,
        }}
        transition={{duration:0.7,delay:0.2,type:"tween"}}
        whileInView={{opacity:1,
            }}
        style={{color:"white",display:"flex",alignItems:"center",justifyContent:"center",marginTop:"150px"}}>Projects</motion.h1>
       <motion.div 
        initial={{opacity:0,
            }}
        transition={{duration:0.7,delay:0.2}}
        whileInView={{opacity:1,
            }}
       style={{
        marginLeft:"20px"
       }}> {catogary.map((e,i)=><Tabs name={e} index={i} Tab={Tab} changeTab={changeTab} key={i}/>)}</motion.div>
       <div style={{display:"flex",flexWrap:"wrap",alignItems:"center",justifyContent:"center"}}>
        {(Tab===0)?Projects.filter((e)=>e.catogary==="WebSite").map((e,i)=><Card title={e.name} discription={e.discription} github={e.github} online={e.online} download={e.download} key={Math.random()} image={e.image}/>)
    :(Tab===1)?Projects.filter((e)=>e.catogary==="Applications").map((e,i)=><Card title={e.name} discription={e.discription} github={e.github} online={e.online} download={e.download} key={Math.random()} image={e.image}/>)
    :Projects.filter((e)=>e.catogary==="Web Games").map((e,i)=><Card title={e.name} discription={e.discription} github={e.github} online={e.online} download={e.download} key={Math.random()} image={e.image}/>)
    }
       </div>
    </div>
}
function Tabs({name,index,Tab,changeTab}){
    return <button 
   
    style={{
        backgroundColor:!(Tab===index)?"black":"white",
        outline:"none",
        margin:"10px",
        padding:"15px",
        border:"2px solid white",
        borderRadius:"10px",
        fontWeight:"900",
        transition:"0.5s",
         boxShadow:(Tab===index)?"0px 0px 30px 3px rgba(255,255,255,0.4)":"",
        color:!(Tab===index)?"white":"black",
    }} onClick={()=>{
        changeTab(index)
    }}>
        {name}
    </button>
}
function Card({title,discription,github,online,download,image}){
   return <motion.div 
   initial={
    {
        opacity:0,
        y:100
    }
   }
   transition={{duration:0.7}}
   whileInView={{opacity:1,
    y:0}}
   className="container">
        <div className="card" style={
            {
                color: "#009688"
            }
        }>
            <div className="img-box">
                <img src={image} alt="No"/>
            </div>
            <div className="content">
                <h2>{title}</h2>
                <p className="MainContent">
                   {discription}
                </p>
                <p style={{display:"flex",justifyContent:"space-evenly",fontSize:"25px",height:"30px"}}>
                <a style={{display:"inline",fontSize:"25px",color:"black"}} href={github} target="_blank" rel="noreferrer"><i className="fa-brands fa-github icons" ></i></a>
                {download!==""&&<a style={{display:"inline",fontSize:"25px",color:"black"}} href={download}><i class="fa-solid fa-download"></i> </a>}
                {online!==""&&<a style={{display:"inline",fontSize:"25px",color:"black"}} href={online} target="_blank" rel="noreferrer"><i class="fa-solid fa-location-arrow"></i></a>}                
                </p>
            </div>
        </div>
        </motion.div>
}